var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc11Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "49.2866mm",
    height: "12.9488mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 10697.04 2810.37",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2464982117360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2465002844480"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M3174.43 2810.37l-3174.43 0 0 -2810.37 3174.43 0 0 2810.37zm-3126.19 -48.25l3077.94 0 0 -2713.88 -3077.94 0 0 2713.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1475.25 1302.4l-1163.99 0 0 -996.9 1163.99 0 0 996.9zm-1115.77 -48.81l1067.52 0 0 -899.27 -1067.52 0 0 899.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M2863.77 1302.4l-1164.58 0 0 -996.9 1164.58 0 0 996.9zm-1116.33 -48.81l1066.37 0 0 -899.27 -1066.37 0 0 899.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1475.25 2504.87l-1163.99 0 0 -996.31 1163.99 0 0 996.31zm-1115.77 -48.25l1067.52 0 0 -899.84 -1067.52 0 0 899.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M2863.77 2504.87l-1164.58 0 0 -996.31 1164.58 0 0 996.31zm-1116.33 -48.25l1066.37 0 0 -899.84 -1066.37 0 0 899.84z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2464990770528"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "nonzero",
    d: "M6934.59 2810.37l-3174.43 0 0 -2810.37 3174.43 0 0 2810.37zm-3126.19 -48.25l3077.96 0 0 -2713.88 -3077.96 0 0 2713.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "nonzero",
    d: "M6623.35 1302.4l-2552.53 0 0 -996.9 2552.53 0 0 996.9zm-2504.29 -48.81l2456.04 0 0 -899.27 -2456.04 0 0 899.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "nonzero",
    d: "M6623.35 2504.87l-2552.53 0 0 -996.31 2552.53 0 0 996.31zm-2504.29 -48.25l2456.04 0 0 -899.84 -2456.04 0 0 899.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2464990775424"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M10694.17 2810.37l-3171.57 0 0 -2810.37 3174.43 0 -2.86 2810.37zm-3126.19 -48.25l3077.94 0 0 -2713.88 -3077.94 0 0 2713.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M10383.51 1684.28l-1164.58 0 0 -1378.19 1164.58 0 0 1378.19zm-1116.33 -48.81l1069.23 0 0 -1281.15 -1068.08 0 -1.15 1281.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M10383.51 2504.87l-1164.58 0 0 -614.45 1164.58 0 0 614.45zm-1116.33 -48.25l1069.23 0 0 -516.83 -1068.08 0.02 -1.15 516.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M9015.65 2504.87l-1166.86 0 0 -1378.19 1166.86 0 0 1378.19zm-1116.33 -48.25l1067.52 0 0 -1281.71 -1069.82 0 2.3 1281.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M9015.65 918.81l-1166.86 0 0 -613.3 1166.86 0 0 613.3zm-1116.33 -48.25l1067.52 0 0 -516.83 -1069.82 0.02 2.3 516.81z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc11Big);
export default __webpack_public_path__ + "static/media/ic_1_1_big.978e76fe3ebce9377f6eac3d08138ca0.svg";
export { ForwardRef as ReactComponent };